<footer class="align-items-center border-color-ci-6 border-top-1 color-ci-1-b flex flex-column sm:flex-row flex-wrap gap-inner m-3 p-default text-sm">
  <div>Fleet Online {{ version }}</div>
  <div>
    <a href="https://www.isp-solutions.tech" target="_blank" rel="noopener noreferrer">&copy; INTELLIGENT SHIP PERFORMANCE SOLUTIONS</a>
  </div>
  <div>
    <a href="https://www.isp-solutions.tech/imprint" target="_blank" rel="noopener noreferrer">Imprint</a>
  </div>
  <div>
    <a href="https://www.isp-solutions.tech/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
  </div>
</footer>
